module.exports = __webpack_public_path__ + "img/appt_banner.2dbdb953.gif";